module.exports = __webpack_public_path__ + "img/img8.bc28d8fc.png";